<script>
export default {
    name: 'PortraitPhoto',
    props: {
        photo: [Object, Boolean],
        slug: String,
        hasBio: Boolean,
        name: String,
        size: String,
    },
    methods: {
        onBioClick(event) {
            event.preventDefault();
            if (this.hasBio) {
                this.$store.dispatch('openOverlayPage', { 
                    component: 'ContributorPage', 
                    props: { 
                        slug: this.slug 
                    }
                });
            }
        },
    },
    computed: {
        photoSrc() {
            if (this.photo.sizes)
                return this.size === 'large' ? this.photo.sizes.large : this.photo.sizes.portrait;
        }
    }
};
</script>

<template>
    <div class="portrait-photo" v-bind:class="{'portrait-photo--large': size === 'large'}">
        <img 
            class="portrait-photo__img" 
            v-if="photo"
            v-bind:src="photoSrc" 
            v-bind:alt="$t('contributorPortrait.portrait') + ' ' + name">
        <div class="portrait-photo__img-shader" v-on:click="onBioClick($event)"></div>
    </div>
</template>

<style lang="scss" scoped>
.portrait-photo {
    position: relative;
    width: 10rem; height: 10rem;
    min-width: 10rem;
    margin-top: -1.6rem;
    overflow: hidden;
    border-radius: 50%;
    background: lighten($color-primary, 60%);
}
.portrait-photo--large {
    width: 29rem; height: 29rem;

    @include breakpoint('sm-down') {
        width: 24rem; height: 24rem;
    }
}
.portrait-photo__img {
    width: 100%; height: 100%;
    object-fit: cover;
    filter: grayscale(100%);
    border-radius: 50%;
}
.portrait-photo__img-shader {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    background: rgba($color-secondary-alt, .06);
    border-radius: 50%;
}
</style>
